import { Result } from 'antd'
import { ReactComponent as PrefectosIcon } from '../../assets/svg/PrefectosIcon.svg'

const PlaceholderContent = () => {
    return (
        <Result
            icon={<PrefectosIcon />}
            title="Welcome to WhatsApp Customer Care"
            subTitle="You're connected to the Prefectos Network. Stay on top of your conversations, assist customers efficiently, and collaborate with your team."
        />
    )
}

export default PlaceholderContent